import { defaultSelectedBanner } from './state'

export function setBanners(state, banners) {
    state.banners = banners
}
export function setBrands(state, brands) {
    state.brands = brands.map(p => {
        return {value:p.id, brand: p.description, img:p.image}
    })
}

export function setProds(state, prods) {
	state.prods = prods
}

export function setModalServiceShow(state, modalServiceShow) {
    state.modalService.show = modalServiceShow
}

export function setModalSalesShow(state, modalSalesShow) {
    state.modalSales.show = modalSalesShow
}
export function setSalesBudgetShow(state, salesBudget) {

    salesBudget.map(s => {
        s.viewDetail = false
    })

    state.salesBudget = salesBudget
}

/**
 * Establecer un valor para la variable lines_products.
 */
export function setLinesProducts(state, lines_products) {
    state.lines_products = lines_products;
}

/**
 * Establecer un valor para la variable lines_customers.
 */
export function setLinesCustomers(state, lines_customers) {
    state.lines_customers = lines_customers;
}